export default __webpack_public_path__ + "static/media/store-level-4.8eef7c86.png";